import L from "leaflet";
import React from "react";
import { Marker, Popup } from "react-leaflet";
import star from "../../../assets/star.png";
import { sendWarpEvent } from "../../../helper/WebsocketClient";
import { coreDataStore } from "../../../helper/CoreDataStorage";
import { Warp } from "../../../types/Warps";

interface Props {
  ride_data: Warp;
  x: number;
  y: number;
}

const RideMarker: React.FC<Props> = ({ ride_data, y, x }) => {
  const isNew = ride_data.new;

  const icon = L.divIcon({
    html: `
      <div class="relative w-full h-full flex items-center justify-center pointer-events-none">
        ${
          isNew
            ? `<div class="absolute -top-5 left-1/2 -translate-x-1/2 bg-red-600 text-white text-[12px] font-bold px-2 py-0.5 rounded-xl rotate-[-8deg] shadow-md whitespace-nowrap z-10 font-sans">NEW</div>`
            : ""
        }
        <div class="p-[5px] bg-violet-100 border-2 border-violet-300 rounded-full pointer-events-none">
          <img src="${star}" class="w-[30px] h-[30px] pointer-events-none" />
        </div>
      </div>
    `,
    iconSize: [30, 30],
    iconAnchor: [15, 15],
    className: "",
  });

  return (
    <Marker position={[y, x]} icon={icon}>
      <Popup className="ride-popup">
        <div className="w-[200px] h-auto bg-gray-900 text-white rounded-lg overflow-hidden">
          {ride_data.image && (
            <img
              src={ride_data.image}
              className="w-full h-24 object-cover"
              alt=""
            />
          )}
          <div className="p-2 flex flex-col items-start justify-between select-none">
            <h1 className="text-xl">{ride_data.name}</h1>
            <p className="bg-red-600 rounded-full px-2 py-1 text-xs">Ride</p>
            <h2 className="text-base">{ride_data.description}</h2>
            <button
              className="mt-3 w-full bg-transparent hover:opacity-80 border-2 text-white py-2 rounded-xl"
              onClick={() => {
                if (
                  coreDataStore.ws &&
                  coreDataStore.session_token &&
                  coreDataStore.ws.OPEN
                ) {
                  sendWarpEvent(
                    coreDataStore.ws,
                    coreDataStore.session_token,
                    ride_data,
                  );
                }
              }}
            >
              Click to warp
            </button>
          </div>
        </div>
      </Popup>
    </Marker>
  );
};

export default RideMarker;
